interface Language {
  countryCode: string;
  defaultCountry: string;
  defaultLanguageCode: string;
  languageCode: string;
}

const useLanguage = (intlOverride: string | null = null): Language => {
  const language = intlOverride || process.env.GATSBY_LANGUAGES || "";

  return {
    countryCode: language.substring(3).toLowerCase(),
    defaultCountry: language.substring(3).toLowerCase(),
    defaultLanguageCode: language.substring(0, 2),
    languageCode: language.substring(0, 2),
  };
};

export default useLanguage;
